/* Fin de challenge — validation — TC-04 (Bible §52 · ADM-18/MER-86).
   Winner approval and the fulfilment record. Corrections and appeals follow
   the terms declared before the challenge started: reassigning or withdrawing
   a QR keeps the historical attribution, and a correction changes the
   effective attribution through audited events — it never rewrites history. */
import { Button, ErrorState, KV } from '@/ui'
import { useClosure } from './api'
import { Chargement, Retour } from './parts'

export default function Validation() {
  const { data, isPending, isError, refetch } = useClosure()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger la validation."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 700 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Fin de challenge — validation</h2>

      <KV rows={[
        ['Gagnante proposée', <span key="w"><b>{data.winner}</b> · {data.winnerDetail}</span>],
        ['Examens fraude', data.fraudReviews],
        ['Reconnaissance', data.recognition],
        ['Remise effectuée', data.fulfilment],
      ]} />

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="primary">Approuver le résultat</Button>
        <Button size="sm" variant="quiet">Voir le journal</Button>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        Réaffecter/retirer un QR conserve l’attribution historique&nbsp;; les corrections
        changent l’attribution effective par événements audités, jamais en réécrivant
        l’historique.
      </p>
    </div>
  )
}
